import api from "../../../../../../services/api";
import { IAnexo } from "../../../../../../utility/IAnexo";
import { ArquivoUploadInfo } from "../../../../ComponenteArquivos/utils";
import { TAMANHO_MAXIMO_ARQUIVO } from "../../../../ComponenteArquivosProposta/utils";

export const carregarArquivosOrientacao = async (idOrientacao: number, idProposta: number): Promise<IAnexo[]> => {
    try {
        const resposta = await api.get(`orientacao?filtros[id_orientacao]=${idOrientacao}`);

        if (resposta.data.status === 'success' && Array.isArray(resposta.data.result) && resposta.data.result.length > 0) {
            const orientacao = resposta.data.result[0];

            if (orientacao.arquivos && Array.isArray(orientacao.arquivos)) {
                return orientacao.arquivos.map((arquivo: any) => ({
                    id_proposta_arquivo: arquivo.id_orientacao_arquivo,
                    id_orientacao_arquivo: arquivo.id_orientacao_arquivo,
                    id_proposta: idProposta,
                    caminho: arquivo.caminho,
                    criado: arquivo.criado,
                    modificado: arquivo.modificado,
                    nome_responsavel: arquivo.nome_responsavel,
                    tipo_responsavel: arquivo.tipo_responsavel,
                    tamanho: arquivo.tamanho || 0
                }));
            }
        }
        return [];
    } catch (erro) {
        throw new Error("Erro ao buscar arquivos da orientação");
    }
};

export const enviarArquivoOrientacao = async (
    arquivo: File,
    indice: number,
    idProposta: number,
    definirUploads: React.Dispatch<React.SetStateAction<ArquivoUploadInfo[]>>,
    aoAdicionarAnexo: ((anexo: IAnexo) => void) | undefined,
    idOrientacao?: number,
    sessionId?: string
): Promise<{ sucesso: boolean; arquivo: File; dados?: any; anexo?: IAnexo }> => {
    const dados = new FormData();
    dados.append("arquivo", arquivo);

    try {
        let resposta: any;
        let dadosArquivo: any;

        const url = sessionId 
            ? `fileupload-orientacao?demandaId=${idProposta}&sessionId=${sessionId}`
            : `fileupload-orientacao?demandaId=${idProposta}`;

        resposta = await api.post(
            url,
            dados,
            {
                onUploadProgress: (evento: ProgressEvent) => {
                    if (!evento.total) {
                        return;
                    }
                    const percentual = Math.round((evento.loaded * 100) / evento.total);
                    definirUploads((anteriores) =>
                        anteriores.map((item, posicao) =>
                            posicao === indice ? { ...item, progresso: percentual } : item
                        )
                    );
                }
            }
        );

        dadosArquivo = resposta.data;

        definirUploads((anteriores) =>
            anteriores.map((item, posicao) =>
                posicao === indice ? { ...item, status: "sucesso", progresso: 100 } : item
            )
        );

        const caminho = dadosArquivo?.caminho;
        if (caminho) {
            const novoAnexo: IAnexo = {
                id_proposta_arquivo: dadosArquivo?.id_orientacao_arquivo,
                caminho,
                id_proposta: idProposta,
                tamanho: dadosArquivo?.tamanho || arquivo.size,
                criado: dadosArquivo?.criado || new Date().toISOString(),
                modificado: dadosArquivo?.modificado || new Date().toISOString(),
                nome_responsavel: dadosArquivo?.nome_responsavel,
                tipo_responsavel: dadosArquivo?.tipo_responsavel,
                email_responsavel: dadosArquivo?.email_responsavel
            };
            return { sucesso: true, arquivo, dados: dadosArquivo, anexo: novoAnexo };
        }

        return { sucesso: true, arquivo, dados: dadosArquivo };
    } catch (erro: any) {
        const mensagem = erro?.response?.data?.message || erro?.message || "Erro ao enviar arquivo";

        definirUploads((anteriores) =>
            anteriores.map((item, posicao) =>
                posicao === indice ? { ...item, status: "erro", erro: mensagem } : item
            )
        );

        return { sucesso: false, arquivo };
    }
};

export const validarTamanhoArquivo = (arquivo: File): boolean => {
    return arquivo.size <= TAMANHO_MAXIMO_ARQUIVO;
};

